import type { NavBarExtension } from '@pflegenavi/frontend/layout';

import { nhAppMainPages } from '@pflegenavi/frontend/routing';

import { Typography } from '@mui/material';
import {
  useEmployeeIsNursingHomeAdmin,
  useEmployeeIsNursingHomeAdminOrManager,
  useNursingHomeContext,
} from '@pflegenavi/frontend/nursing-home-context';
import { Label, SvgIconStyle } from '@pflegenavi/web-components';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import nursingHome from './assets/nursing_home_24dp.svg';
import { useCanSeeEmployeeList } from './hooks/hasPermission';

export const useConfig: () => NavBarExtension = () => {
  const isNursingHomeAdmin = useEmployeeIsNursingHomeAdmin();
  const isNursingHomeAdminOrManager = useEmployeeIsNursingHomeAdminOrManager();

  const { selectedNursingHome } = useNursingHomeContext();

  const { t } = useTranslation();

  const paymentsDisabledInfo = useMemo(() => {
    if (!selectedNursingHome?.paymentsDisabled) {
      return undefined;
    } else {
      return (
        <Label variant="outlined" color="error">
          <Typography variant={'inherit'} mr={0.1} mt={0.15}>
            €
          </Typography>
        </Label>
      );
    }
  }, [selectedNursingHome?.paymentsDisabled]);

  const canSeeEmployeeList = useCanSeeEmployeeList();

  const navChildren = useMemo(() => {
    return [
      ...(isNursingHomeAdmin
        ? [
            {
              title: t('common.overview'),
              path: nhAppMainPages.NURSING_HOME,
            },
          ]
        : []),
      ...(canSeeEmployeeList
        ? [
            {
              title: t('employees-management.employees-list.title'),
              path: nhAppMainPages.NURSING_HOME_EMPLOYEES_LIST,
            },
          ]
        : []),
    ];
  }, [t, canSeeEmployeeList, isNursingHomeAdmin]);

  if (!isNursingHomeAdminOrManager) {
    return undefined;
  }

  return {
    item: {
      icon: (
        <SvgIconStyle
          src={nursingHome}
          sx={{
            width: 1,
            height: 1,
          }}
        />
      ),
      title: t('nursingHome.main'),
      path: nhAppMainPages.NURSING_HOME,
      info: paymentsDisabledInfo,
      children: navChildren,
    },
  };
};
